
export default function AboutSection() {
  const credentials = [
    {
      icon: "fas fa-shield-alt",
      title: "Licensed & Bonded",
      description: "Fully licensed debt settlement company"
    },
    {
      icon: "fas fa-award",
      title: "BBB Accredited",
      description: "A+ rating with Better Business Bureau"
    },
    {
      icon: "fas fa-users",
      title: "Personalized Service",
      description: "Dedicated specialists for each client"
    },
    {
      icon: "fas fa-chart-bar",
      title: "Proven Results",
      description: "16+ years of successful settlements"
    },
    {
      icon: "fas fa-phone-alt",
      title: "24/7 Support",
      description: "Always available when you need us"
    }
  ];

  return (
    <section id="about" className="py-20 bg-slate-900">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="text-sm text-gray-400 uppercase tracking-wide mb-4">ESTABLISHED 2008</div>
          <h2 className="text-4xl md:text-6xl font-serif text-white mb-8 leading-tight">
            16+ Years of Helping<br />
            Americans Reclaim<br />
            <span className="text-orange-400">Financial Freedom</span>
          </h2>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center mb-16">
            <button 
              onClick={() => {
                document.querySelector('#about')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-white text-slate-900 px-8 py-3 rounded-full text-lg font-semibold hover:bg-gray-100 transition-all duration-300 whitespace-nowrap"
            >
              Our Story
            </button>
            <button 
              onClick={() => {
                document.querySelector('#testimonials')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-3 rounded-full text-lg font-semibold transition-all duration-300 whitespace-nowrap"
            >
              Success Stories
            </button>
          </div>
        </div>

        <div className="mb-16">
          <div className="bg-slate-800 rounded-2xl p-8 md:p-12">
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
              <div>
                <h3 className="text-3xl font-bold text-white mb-6">Our Mission</h3>
                <p className="text-gray-300 text-lg leading-relaxed mb-6">
                  Since 2008, Brite Solutions has been dedicated to helping Americans break free from overwhelming debt. 
                  We started by focusing on consumer debt relief, but as the financial landscape changed and businesses 
                  began struggling with predatory merchant cash advance loans, we expanded our expertise.
                </p>
                <p className="text-gray-300 text-lg leading-relaxed mb-6">
                  Today, we're proud to be one of the nation's leading debt settlement companies, specializing in both 
                  consumer and business debt relief. Our licensed professionals have successfully negotiated over $500 
                  million in debt settlements, helping thousands of clients achieve financial freedom.
                </p>
                <p className="text-orange-400 text-lg font-semibold">
                  Your financial freedom is our commitment.
                </p>
              </div>
              <div>
                <img 
                  src="https://public.readdy.ai/ai/img_res/42ffaecff8e617e3ed5cbdb779ea4586.jpg"
                  alt="Brite Solutions Team"
                  className="w-full h-80 object-cover rounded-xl"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Credentials */}
        <div className="grid grid-cols-1 md:grid-cols-5 gap-6">
          {credentials.map((credential, index) => (
            <div key={index} className="bg-slate-800 rounded-lg p-6 text-center">
              <div className="w-12 h-12 bg-orange-500 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${credential.icon} text-white text-lg`}></i>
              </div>
              <h4 className="text-white font-semibold mb-2">{credential.title}</h4>
              <p className="text-gray-400 text-sm">{credential.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
